import { P2GFade } from '@parcel2go/peacock-legacy-core/dist/transitions';
import React, { useContext, useMemo } from 'react';
import { useSessionStorage } from '../hooks/useSessionStorage';
import { ActionType, IntegrationStatus, IntegrationType } from '../services/api/types';
import { NotificationContext } from '../services/contexts/NotificationContext';
import AccountNotification from './AccountNotification';

interface props {}

export interface NotificationModel {
  note?: string;
  id: string;
  color?: 'info' | 'warning' | 'error' | 'success';
  actions?: ActionType[];
  integrationType?: IntegrationType;
  integrationSlug?: string;
  status?: IntegrationStatus;
  accountId?: string;
  showClose: boolean;
  configRequired?: boolean;
  success?: boolean;
  action?: ActionType;
}

const AccountNotifications: React.FC<props> = (props) => {
  const notificationContext = useContext(NotificationContext);
  const [seen, setSeen] = useSessionStorage<string[]>('ACCOUNT_SEEN', []);

  const notifications = useMemo(() => {
    return notificationContext.state.filter((x) => !seen.includes(x.id));
  }, [seen, notificationContext.state]);

  const close = (id: string) => {
    setSeen([...seen, id]);
    notificationContext.dispatch({ type: 'REMOVE', payload: { id: id, showClose: false } });
  };

  return (
    <>
      {notifications.map((n, i) => (
        <P2GFade in timeout={i * 550} key={n.id}>
          <AccountNotification notification={n} onClose={() => close(n.id)} />
        </P2GFade>
      ))}
    </>
  );
};

export default AccountNotifications;
